import { useFileMinifiedQuery } from '../graphql/queries/generated/fileMinified';

export default function useFile(fileId?: string) {
  const [{ data, fetching, error }] = useFileMinifiedQuery({
    variables: {
      filters: {
        id: fileId!,
      },
    },
    pause: !fileId,
    requestPolicy: 'cache-first',
  });

  return { fetching, file: data?.file, error };
}
